import { CircularProgress as MUICircularProgress } from "@mui/material";

export const CircularProgress = MUICircularProgress;
